module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-success"
  }, [_vm._m(0), _vm._v(" "), (_vm.isMounted) ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('b', [_vm._v("Recibido")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-top": "30px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "center-block",
    staticStyle: {
      "width": "150px"
    }
  }, [_c('chart-projection-received', {
    ref: "chartReceived",
    attrs: {
      "chart-data": _vm.projectionChartDataReceived,
      "width": 100,
      "height": 100
    }
  })], 1)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('div', {
    staticClass: "text-center center-block",
    staticStyle: {
      "width": "150px"
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "text-bottom"
    },
    attrs: {
      "src": "/static/img/icons/ic_storage_arrived@3x.png",
      "alt": "Ingresadas",
      "height": "20",
      "width": "20"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "span-value",
    style: (_vm.formatAmountColor(this.fetchData.recivedPercentageWarehouse))
  }, [_vm._v("\n                    " + _vm._s(_vm._f("formatAmount")(this.fetchData.recivedAmountWarehouse))), _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(" " + _vm._s(this.fetchData.minimumStockUnit))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "span-status"
  }, [_vm._v("Recibido")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('div', {
    staticClass: "text-center center-block",
    staticStyle: {
      "width": "150px"
    }
  }, [_c('i', {
    staticClass: "fa fa-bullseye",
    style: ({
      color: this.colorProjected
    })
  }), _vm._v(" "), _c('span', {
    staticClass: "span-value",
    style: ({
      color: this.colorProjected
    })
  }, [_vm._v("\n                    " + _vm._s(_vm._f("formatAmount")(this.fetchData.recivedAmountProjectionWarehouse))), _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(" " + _vm._s(this.fetchData.minimumStockUnit))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "span-status"
  }, [_vm._v("Proyectado")])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 chartPadding"
  }, [_c('chart-line-return', {
    attrs: {
      "chart-data": _vm.lineChartDataReceived,
      "height": 240
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('b', [_vm._v("Despachado")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-top": "30px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "center-block",
    staticStyle: {
      "width": "150px"
    }
  }, [_c('chart-projection-shipped', {
    ref: "chartShipped",
    attrs: {
      "chart-data": _vm.projectionChartDataShipped,
      "width": 100,
      "height": 100
    }
  })], 1)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('div', {
    staticClass: "text-center center-block",
    staticStyle: {
      "width": "150px"
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "text-bottom"
    },
    attrs: {
      "src": "/static/img/icons/ic_storage_shipped@3x.png",
      "alt": "Ingresadas",
      "height": "20",
      "width": "20"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "span-value",
    style: (_vm.formatAmountColor(this.fetchData.shippedPercentageWarehouse))
  }, [_vm._v("\n                    " + _vm._s(_vm._f("formatAmount")(this.fetchData.shippedAmountWarehouse))), _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(" " + _vm._s(this.fetchData.minimumStockUnit))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "span-status"
  }, [_vm._v("Despachado")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('div', {
    staticClass: "text-center center-block",
    staticStyle: {
      "width": "150px"
    }
  }, [_c('i', {
    staticClass: "fa fa-bullseye",
    style: ({
      color: this.colorProjected
    })
  }), _vm._v(" "), _c('span', {
    staticClass: "span-value",
    style: ({
      color: this.colorProjected
    })
  }, [_vm._v("\n                    " + _vm._s(_vm._f("formatAmount")(this.fetchData.shippedAmountProjectionWarehouse))), _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(" " + _vm._s(this.fetchData.minimumStockUnit))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "span-status"
  }, [_vm._v("Proyectado")])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 chartPadding"
  }, [_c('chart-line-return', {
    attrs: {
      "chart-data": _vm.lineChartDataShipped,
      "height": 240
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('b', [_vm._v("Devolución")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-top": "100px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "center-block",
    staticStyle: {
      "width": "170px"
    }
  }, [_c('div', {
    staticClass: "pull-left text-center",
    staticStyle: {
      "width": "170px"
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "text-bottom"
    },
    attrs: {
      "src": "/static/img/icons/ic_returned@3x.png",
      "alt": "Ingresadas",
      "height": "20",
      "width": "20"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "span-value",
    style: ({
      color: this.colorReturned
    })
  }, [_vm._v("\n                      " + _vm._s(_vm._f("formatAmount")(this.fetchData.returnedAmountWarehouse))), _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(" " + _vm._s(this.fetchData.minimumStockUnit))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "span-status"
  }, [_vm._v("Devoluciones")])])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 chartPadding"
  }, [_c('chart-line-return', {
    attrs: {
      "chart-data": _vm.lineChartDataReturn,
      "height": 240
    }
  })], 1)])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title box-title-sub"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/icons/almacen-verde.png"
    }
  }), _vm._v(" Almacén")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-75306c00!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/WarehouseSummary.vue
// module id = 530
// module chunks = 1